import LogoPane from './LogoPane';
import ContentPane from './ContentPane';

function SplitPane() {
  const style = {
    position: 'relative',
    top: '100px',
  };

  // left sidebar with content
  // based on: https://superdevresources.com/fixed-width-sidebar/
  return (
    <div style={style}>
      <div className="page">
        <div className="wrapper">
          <div className="content-wrapper">
            <div className="content">
              <div className="topbar">
                <h2>Poly RealConnect for Office 365 and Microsoft Teams</h2>
                <hr />
              </div>
              <ContentPane />
            </div>
          </div>
          <div className="sidebar">
            <LogoPane />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SplitPane;
